const table = {
  
}


export default table;